import React, { useEffect, useState } from 'react';
import './style.css';
import { Row, Col, Table, Input, Spin, Button, DatePicker, Select, Tabs } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useHistory, Redirect } from "react-router-dom";
import { getFileRefrence, viewDashboardSelector, clearState } from './DDsAndAdsDashboardSlice';
import moment from 'moment';

const ntop = "none";
const nbottom = "bottomCenter";
const { Search } = Input;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

export default function FileReferenceStatus(props) {
    const { Option } = Select;
    const dispatch = useDispatch();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const [FileRefData, setFileRefData] = useState([]);
    const [page, setPage] = useState(1);


    const { isFileRefSuccess, fileRefrenceData, fileRefCount } = useSelector(
        viewDashboardSelector
    );

    useEffect(() => {
        if (isFileRefSuccess) {
            setFileRefData(fileRefrenceData);
            dispatch(clearState());
        }
    }, [isFileRefSuccess, fileRefrenceData, fileRefCount]);

    const renderContent = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        return obj;
    };

    const refcolumns = [
        {
            title: "File Reference",
            dataIndex: "reference_no",
            render: renderContent,
        },
        {
            title: "Description",
            dataIndex: "desc",
            render: renderContent,
        }

    ];

    const refdata = [
        {
            id: 1,
            reference_no: "123456",
            desc: "Dummy data,Dummy data,Dummy data,Dummy data Dummy data,Dummy data,Dummy data,Dummy data,Dummy data Dummy data,Dummy data,Dummy data,",
        }
    ];

    const ChangeIncomingPagination = (v) => {

        let q = '&page=' + v.current + '&limit=10';
        setPage(v.current);
        dispatch(getFileRefrence(q));

    }


    let dataSourceFileRef = isLoading
        ? []
        : FileRefData && FileRefData.length > 0 ? FileRefData.map((row, key) => ({
            id: row._id,
            reference_no: row.ref,
            desc: row.description,

        })) : [];


    return (
        <>
            {/* table code.. */}

            <Table
                columns={refcolumns}
                onChange={ChangeIncomingPagination}
                pagination={{
                    position: [ntop, nbottom],
                    size: "small",
                    defaultPageSize: 10,
                    total: fileRefCount ? fileRefCount : 0,
                    hideOnSinglePage: true,
                }}
                dataSource={dataSourceFileRef}
                // className="clerk-dashboard-tab-sec-file-ref"
                bordered
            />
        </>
    );
}